import { configureStore } from "@reduxjs/toolkit";
import reportConfigReducer from "../features/reportConfig/reportConfigSlice";
import messagingConfigReducer from "../features/messagingConfig/messagingConfigSlice";

const store = configureStore({
  reducer: {
    reportConfig: reportConfigReducer,
    messagingConfig: messagingConfigReducer,
  },
});

export default store;
